<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="方案名称 ">
              <a-input placeholder="请输入方案名称" v-model="queryParam.schemeName"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>
              </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="formDesignHandle(record)">方案设计</a>
          <a-divider type="vertical" />
          <span v-if="record.status == 0">
            <a @click="enableScheme(record.id)">启用</a>
            <a-divider type="vertical" />
          </span>
          <span v-if="record.status == 1">
            <a @click="disableScheme(record.id)">禁用</a>
            <a-divider type="vertical" />
          </span>
          <a @click="handleDeleteSchema(record.id)">删除</a>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <schema-model ref="modalForm" @close="modelClose"></schema-model>

    <form-design-model ref="modalFormDesignSchema" @changeFormDesignTab="changeFormDesignTab"  @reload="searchQuery" kDesignType="SCHEMA_DESIGN"></form-design-model>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import SchemaModel from './schema/SchemaModel'
import FormDesignModel from '@views/tempconfig/formDesign/FormDesignModel'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { deleteAction,getAction ,postAction } from '@/api/manage'

export default {
  name: "TempConfigSchema",
  mixins:[JeecgListMixin],
  components: {
    SchemaModel,
    FormDesignModel
  },
  data () {
    return {
      disableMixinCreated:true,
      /* 排序参数 */
      isorter:{
        column: 'createTime',
        order: 'desc',
      },
      description: '项目配置-知识库-方案设计页面',
      // 表头
      columns: [
        {
          title: '方案名称',
          align: 'center',
          dataIndex: 'schemeName',
          width: 150
        },
        {
          title: '方案实施的时间长度',
          align: 'center',
          dataIndex: 'duration',
          width: 80
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status',
          width: 80,
          customRender(text){
              let result = ''
              if('1' == text){
                result = '已启用'
              }
              else if('0' == text){
                result = '已禁用'
              }
              return result
            }
        },        
        {
          title: '备注',
          dataIndex: 'remark',
          align: 'center',
          ellipsis: true,
          width: 150
        },
        {
          title: '操作',
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'action' },
        }
      ],
      url: {
        list:'/scheme/page/list'
      },
      loading: false,
    }
  },
  mounted(){
    this.loadData()
  },
  methods:{
    modelClose(){
      this.loadData()
    },
    formDesignHandle(record){
      this.$refs.modalFormDesignSchema.view()
      this.$refs.modalFormDesignSchema.selectedSchema(record)
    },
    enableScheme(id){
      this.$confirm({
        title: '启用方案',
        content: (<div>
          <p>您确定要启用这个方案吗？</p>
        </div>),
        centered: false,
        onOk: () => {
          this.loading = true
          getAction("/scheme/enable", {schemeId: id}).then((res) => {
            if (res.success) {
              this.$message.success(res.message)
              this.loadData()
            } else {
              this.$message.error(res.message || '操作失败');
            }
          }).finally(() => {
            this.loading = false
          })
        },
      })
    },
    disableScheme(id){
      this.$confirm({
        title: '禁用方案',
        content: (<div>
          <p>您确定要禁用这个方案吗？</p>
        </div>),
        centered: false,
        onOk: () => {
          getAction("/scheme/disable", {schemeId: id}).then((res) => {
            if (res.success) {
              this.$message.success(res.message)
              this.loadData()
            } else {
              this.$message.error(res.message || '操作失败');
            }
          });
        },
        onCancel() {
        },
      })
    },
    changeFormDesignTab(targetTab, formInfo) {
      console.log("changeFormDesignTab: ", targetTab, formInfo);
      this.$refs.modalFormDesignSchema.changeFormDesignTab(targetTab, formInfo);
    },
    handleDeleteSchema(id) {
      this.$confirm({
        title: '彻底删除方案',
        content: (<div>
          <p>您确定要彻底删除这个方案吗？</p>
          <p style="color:red;">注意：彻底删除后将无法恢复，请谨慎操作！</p>
        </div>),
        centered: false,
        onOk: () => {
          deleteAction("/scheme/delete/" + id,{}).then((res) => {
            if (res.success) {
              this.$message.success(res.message)
              this.loadData()
            } else {
              this.$message.error(res.message);
            }
          });
        },
      })
    }
  }
}
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>